import styled from 'styled-components';

const TrackEnrollStyled = styled.div`
  .tracks-card {
    justify-content: space-evenly;
  }
`;

export default TrackEnrollStyled;
